import './styles.scss';
import {formatDeliveryDate} from "../../../utils/date";

export default function AddressCard({
    name,
    address,
    price,
    date,
    deliveryNotice,
    onClick
})
{
    return <div className="address-card" onClick={onClick}>
        {name && <h3 className="address-card__name">{name}</h3>}
        {address && <span className="address-card__address">{address}</span>}
        {price && <span className="address-card__info">Стоимость доставки: {price} ₽</span>}
        {(deliveryNotice || date) && <span className="address-card__info">{deliveryNotice || formatDeliveryDate(date)}</span>}
    </div>
}
